import React, { useEffect, useRef, useState } from "react";
import { Animated, View, StyleSheet, useWindowDimensions } from "react-native";
import config from "../config/config";
import Icon from "./Icon";

function ProgressBar({ step, height, steps }) {
    const animatedValue = useRef(new Animated.Value(-1000)).current;
    const reactive = useRef(new Animated.Value(-1000)).current;
    const popValue = useRef(new Animated.Value(1)).current;

    const [width, setWidth] = useState(0);

    useEffect(() => {
        Animated.timing(animatedValue, {
            toValue: reactive,
            duration: 400,
            useNativeDriver: false,
        }).start();
    }, []);

    useEffect(() => {
        //quick maths for working out the step position / screen size
        if (step < steps + 1) {
            reactive.setValue(-width + (width * step) / steps);
            popValue.setValue(1);

            Animated.timing(popValue, {
                toValue: 1.25,
                duration: 700,
                useNativeDriver: false,
            }).start();
        }
    }, [step, width]);

    return (
        <View style={styles.component}>
            {/* use the onlayout event to get the width of the view */}
            <View
                onLayout={(e) => {
                    const newWidth = e.nativeEvent.layout.width;
                    setWidth(newWidth);
                }}
            >
                <View
                    style={{
                        height,
                        backgroundColor: config.colors.secondary,
                        borderColor: config.colors.green,
                        borderRadius: height,
                        overflow: "hidden",
                        justifyContent: "center",
                    }}
                >
                    <Animated.View
                        style={{
                            height,
                            backgroundColor: config.colors.tertiary,
                            borderRadius: height,
                            overflow: "hidden",
                            width: "100%",
                            position: "absolute",
                            left: 0,
                            top: 0,
                            transform: [
                                {
                                    translateX: animatedValue,
                                },
                            ],
                        }}
                    />
                </View>
                <View style={styles.icons}>
                    {[...Array(steps)].map((x, index) => (
                        <Animated.View
                            key={index}
                            style={{
                                transform:
                                    step == index
                                        ? [
                                              {
                                                  scale: popValue,
                                              },
                                          ]
                                        : [
                                              {
                                                  scale: 1,
                                              },
                                          ],
                            }}
                        >
                            <Icon
                                name={"numeric-" + (index + 1) + "-box"}
                                backgroundColor={config.colors.tertiary}
                                iconColor={step - 1 >= index ? config.colors.green : config.colors.white}
                                borderWidth={2.5}
                                borderColor={step - 1 >= index ? config.colors.green : config.colors.secondary}
                            />
                        </Animated.View>
                    ))}
                    <Animated.View
                        style={{
                            transform:
                                step == steps
                                    ? [
                                          {
                                              scale: popValue,
                                          },
                                      ]
                                    : [
                                          {
                                              scale: 1,
                                          },
                                      ],
                        }}
                    >
                        <Icon
                            name={"check"}
                            backgroundColor={config.colors.tertiary}
                            borderWidth={2.5}
                            iconColor={step - 1 == steps ? config.colors.green : config.colors.white}
                            borderColor={step - 1 == steps ? config.colors.green : config.colors.secondary}
                        />
                    </Animated.View>
                </View>
            </View>
        </View>
    );
}

const styles = StyleSheet.create({
    component: {
        padding: 20,
    },
    icons: {
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        marginTop: -35,
    },
    stepCounterText: {
        color: config.colors.primary,
        fontWeight: "500",
        paddingLeft: 10,
    },
});

export default ProgressBar;
